/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowParallelHIcon16Light } from './ArrowParallelHIcon16Light';
import { ArrowParallelHIcon16Regular } from './ArrowParallelHIcon16Regular';
import { ArrowParallelHIcon16Solid } from './ArrowParallelHIcon16Solid';
import { ArrowParallelHIcon20Light } from './ArrowParallelHIcon20Light';
import { ArrowParallelHIcon20Regular } from './ArrowParallelHIcon20Regular';
import { ArrowParallelHIcon20Solid } from './ArrowParallelHIcon20Solid';
import { ArrowParallelHIcon24Regular } from './ArrowParallelHIcon24Regular';
import { ArrowParallelHIcon24Solid } from './ArrowParallelHIcon24Solid';
import { ArrowParallelHIcon32Regular } from './ArrowParallelHIcon32Regular';
import { ArrowParallelHIcon64Regular } from './ArrowParallelHIcon64Regular';
var sizes = {
    16: {
        light: ArrowParallelHIcon16Light,
        regular: ArrowParallelHIcon16Regular,
        solid: ArrowParallelHIcon16Solid,
    },
    20: {
        light: ArrowParallelHIcon20Light,
        regular: ArrowParallelHIcon20Regular,
        solid: ArrowParallelHIcon20Solid,
    },
    24: {
        regular: ArrowParallelHIcon24Regular,
        solid: ArrowParallelHIcon24Solid,
    },
    32: {
        regular: ArrowParallelHIcon32Regular,
    },
    64: {
        regular: ArrowParallelHIcon64Regular,
    },
};
export var ArrowParallelHIcon = forwardRef('ArrowParallelHIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
